import * as swcHelpers from '@swc/helpers';
import { uninitState, idleState, reducer, actions, loadingState, failedState, successState, statusSuccess } from '@grandvisionhq/state';
import { fetchList, fetchListFailed, fetchListSuccess, toggleModal, addAddress, addAddressFailed, addAddressSuccess, deleteAddress, deleteAddressConfirm, deleteAddressSuccess, deleteAddressFailed, editAddress, editAddressSave, editAddressSuccess, editAddressFailed } from './actions.js';
import { ViewMode } from './state.js';
import { sortAddresses } from './utils/sort-addresses.js';

const initialState = {
    list: uninitState(),
    pendingListChanges: {},
    calls: {
        add: idleState(),
        edit: idleState()
    },
    modalState: {
        isOpen: false,
        viewMode: ViewMode.ADD
    }
};
const getList = (list)=>statusSuccess(list) ? list.result : []
;
const pushNewAddress = (prevList, newAddress)=>{
    if (newAddress.addressTypes.length) {
        prevList = prevList.map((item)=>{
            if (item.addressTypes.length) {
                const addressTypes = item.addressTypes.filter((addressType)=>!newAddress.addressTypes.includes(addressType)
                );
                return swcHelpers.objectSpread({}, item, {
                    addressTypes
                });
            }
            return item;
        });
    }
    return sortAddresses([
        ...prevList,
        newAddress
    ]);
};
var addressBookReducer = reducer(initialState, /**
   * Fetch address book
   */ actions.on(fetchList, (state)=>swcHelpers.objectSpread({}, state, {
        list: loadingState()
    })
), actions.on(fetchListFailed, (state, action)=>swcHelpers.objectSpread({}, state, {
        list: failedState(action.error)
    })
), actions.on(fetchListSuccess, (state, action)=>swcHelpers.objectSpread({}, state, {
        list: successState(sortAddresses(action.payload))
    })
), /**
   * Toggle modal
   */ actions.on(toggleModal, (state, { payload  })=>swcHelpers.objectSpread({}, state, {
        modalState: swcHelpers.objectSpread({}, state.modalState, payload),
        calls: swcHelpers.objectSpread({}, initialState.calls)
    })
), /**
   * Add address
   */ actions.on(addAddress, (state)=>swcHelpers.objectSpread({}, state, {
        calls: swcHelpers.objectSpread({}, state.calls, {
            add: loadingState()
        })
    })
), actions.on(addAddressFailed, (state, { error  })=>swcHelpers.objectSpread({}, state, {
        calls: swcHelpers.objectSpread({}, state.calls, {
            add: failedState(error)
        })
    })
), actions.on(addAddressSuccess, (state, { payload: newAddress  })=>{
    const prevList = getList(state.list);
    const newAddresses = pushNewAddress(prevList, newAddress);
    return swcHelpers.objectSpread({}, state, {
        calls: swcHelpers.objectSpread({}, state.calls, {
            add: idleState()
        }),
        list: successState(newAddresses),
        modalState: swcHelpers.objectSpread({}, state.modalState, {
            isOpen: false
        })
    });
}), /**
   * Delete address
   */ actions.on(deleteAddress, (state, { payload: id  })=>{
    const prevList = getList(state.list);
    const removedItem = prevList.find((item)=>item.id === id
    );
    return swcHelpers.objectSpread({}, state, {
        pendingListChanges: {
            [id]: removedItem
        },
        currentlyEditingId: id,
        modalState: {
            isOpen: true,
            viewMode: ViewMode.DELETE
        }
    });
}), actions.on(deleteAddressConfirm, (state)=>{
    const prevList = getList(state.list);
    return swcHelpers.objectSpread({}, state, {
        list: successState([
            ...prevList.filter((item)=>item.id !== state.currentlyEditingId
            )
        ]),
        currentlyEditingId: undefined,
        modalState: swcHelpers.objectSpread({}, state.modalState, {
            isOpen: false
        })
    });
}), actions.on(deleteAddressSuccess, (state, { payload: id  })=>{
    const _pendingListChanges = state.pendingListChanges, restPendingChanges = swcHelpers.objectWithoutProperties(_pendingListChanges, [
        id
    ].map(swcHelpers.toPropertyKey));
    return swcHelpers.objectSpread({}, state, {
        pendingListChanges: restPendingChanges
    });
}), actions.on(deleteAddressFailed, (state, { id  })=>{
    if (id) {
        const prevList = getList(state.list);
        const _pendingListChanges = state.pendingListChanges, { [id]: pendingItem  } = _pendingListChanges, restPendingChanges = swcHelpers.objectWithoutProperties(_pendingListChanges, [
            id
        ].map(swcHelpers.toPropertyKey));
        return swcHelpers.objectSpread({}, state, {
            list: successState(sortAddresses([
                ...prevList,
                pendingItem
            ])),
            pendingListChanges: restPendingChanges
        });
    } else {
        return swcHelpers.objectSpread({}, state, {
            modalState: swcHelpers.objectSpread({}, state.modalState, {
                isOpen: false
            })
        });
    }
}), /**
   * Edit address
   */ actions.on(editAddress, (state, { payload: id  })=>{
    const prevList = getList(state.list);
    const editedItem = prevList.find((item)=>item.id === id
    );
    return swcHelpers.objectSpread({}, state, {
        pendingListChanges: {
            [id]: editedItem
        },
        currentlyEditingId: id,
        modalState: {
            isOpen: true,
            viewMode: ViewMode.EDIT
        }
    });
}), actions.on(editAddressSave, (state)=>{
    return swcHelpers.objectSpread({}, state, {
        calls: swcHelpers.objectSpread({}, state.calls, {
            edit: loadingState()
        })
    });
}), actions.on(editAddressSuccess, (state, { payload: editedFields  })=>{
    const prevList = getList(state.list).filter((item)=>item.id !== state.currentlyEditingId
    );
    const editedAddress = swcHelpers.objectSpread({}, state.pendingListChanges[state.currentlyEditingId || 0], editedFields);
    const newAddresses = pushNewAddress(prevList, editedAddress);
    return swcHelpers.objectSpread({}, state, {
        list: successState(newAddresses),
        calls: swcHelpers.objectSpread({}, state.calls, {
            edit: idleState()
        }),
        modalState: swcHelpers.objectSpread({}, state.modalState, {
            isOpen: false
        })
    });
}), actions.on(editAddressFailed, (state, { error  })=>{
    return swcHelpers.objectSpread({}, state, {
        calls: swcHelpers.objectSpread({}, state.calls, {
            edit: failedState(error)
        }),
        modalState: state.modalState
    });
}));

export { addressBookReducer, initialState };
//# sourceMappingURL=reducer.js.map
